import { TFunction } from 'i18next';
import { z } from 'zod';

export const getReleaseNoteByodSchema = (t: TFunction) =>
  z.object({
    description: z.string(),
    version: z
      .string()
      .nonempty(t('common.validation.fieldRequired'))
      .regex(/^\d+\.\d+\.\d+$/, 'El patrón de la versión debe ser: N.N.N'),
  });
